<div *ngFor="let item of data.message">
  {{ item }}
  <mat-icon class="material-icons">error</mat-icon>
</div>
